package es.subastia.favorites

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import es.subastia.domain.usecase.GetFavoritesUseCase
import es.subastia.domain.usecase.ObserveAuthStateUseCase
import es.subastia.domain.usecase.ToggleFavoriteUseCase
import es.subastia.ui.mapper.toUi
import es.subastia.ui.model.AuctionUiModel
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.error_loading_favorites

sealed interface FavoritesUiState {
    data object Loading : FavoritesUiState
    data object NotLoggedIn : FavoritesUiState
    data class Success(val list: List<AuctionUiModel>) : FavoritesUiState
    data class Error(val error: StringResource) : FavoritesUiState
}

class FavoritesViewModel(
    private val observeAuthStateUseCase: ObserveAuthStateUseCase,
    private val getFavoritesUseCase: GetFavoritesUseCase,
    private val toggleFavoriteUseCase: ToggleFavoriteUseCase,
) : ViewModel() {

    @OptIn(ExperimentalCoroutinesApi::class)
    val uiState: StateFlow<FavoritesUiState> = observeAuthStateUseCase()
        .flatMapLatest { user ->
            if (user != null) {
                getFavoritesUseCase(user.uid).map { list ->
                    @Suppress("USELESS_CAST")
                    FavoritesUiState.Success(list.map { it.toUi() }) as FavoritesUiState
                }
            } else {
                flowOf(FavoritesUiState.NotLoggedIn as FavoritesUiState)
            }
        }.catch { e ->
            emit(FavoritesUiState.Error(Res.string.error_loading_favorites))
        }.stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5_000),
            initialValue = FavoritesUiState.Loading,
        )

    fun removeFromFavorites(auctionId: String) {
        viewModelScope.launch {
            val userId = observeAuthStateUseCase().map { it?.uid }.first()
            if (userId != null) {
                toggleFavoriteUseCase(userId, auctionId)
            }
        }
    }
}
